/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-03-03T10:29:11.919
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentPublishChannelConfig,
	listRentPublishChannelConfigInit,
	listRentPublishChannelConfigByAuthorizations,
	deleteRentPublishChannelConfig
} from '@api/rentmanage/RentPublishChannelConfig';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentPublishChannelConfig({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentPublishChannelConfig(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentPublishChannelConfigByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentPublishChannelConfigByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentPublishChannelConfigInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentPublishChannelConfigInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentPublishChannelConfig({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentPublishChannelConfig({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
